export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-3-9c2a9b03ebf1839c8878d693592157b7.jpg";